import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroOrg'
})
export class FiltroOrgPipe implements PipeTransform {

  transform(organizations: any[], search: string = '') {

    if (search.length === 0) {
      return organizations
    }
    const filteredOrganizations: any = organizations.filter(org => org.name_ally.includes(search))
    if (filteredOrganizations.length > 0) {
      return filteredOrganizations;
    } else {
      return filteredOrganizations;
    }
  }

}
